import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleLoaderService {
  private apiLoaded = false;
  private loadPromise: Promise<void> | null = null;
  private googleApiUrl = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&loading=async&callback=__googleMapsCallback`;

  load(): Promise<void> {
    if (this.apiLoaded && (window as any).google?.maps?.places) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      // Define callback that Google Maps will call when ready
      (window as any).__googleMapsCallback = () => {
        this.apiLoaded = true;
        delete (window as any).__googleMapsCallback;
        resolve();
      };

      const script = document.createElement('script');
      script.src = this.googleApiUrl;
      script.async = true;
      script.defer = true;

      script.onerror = (err) => {
        this.loadPromise = null;
        reject(err);
      };

      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
